import { Component } from "react";
import PropTypes from "prop-types";
import { Button, FormGroup, Col, Form, Modal } from "react-bootstrap";
import Input from "../../../shared/Input";
import Error from "../../../shared/Error";

class CollaboratorExpenseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      value: "",
      percentage: false,
      expense_amount: "",
      position: 1,
      isNotValid: false,
      errMsg: "",
    };
  }

  saveExpenseData = () => {
    const { name, value } = this.state;
    const {
      collaboratorModalIndex,
      listingData,
      setFinancialData,
      setIsCollaboratorExpenseModalOpen,
      recalculateCollaboratorExpenses,
    } = this.props;
    if (name && value) {
      const collaboratorExpense = listingData.collaborator_expenses.expenses[collaboratorModalIndex];

      collaboratorExpense.custom_collaborator_expenses_attributes.push(this.state);
      setFinancialData(listingData);
      setIsCollaboratorExpenseModalOpen(false);
      recalculateCollaboratorExpenses(collaboratorExpense, listingData);
    } else {
      this.setState({ errMsg: "Enter a name and value.", isNotValid: true });
    }
  };

  render() {
    const { isCollaboratorExpenseModalOpen, setIsCollaboratorExpenseModalOpen } = this.props;
    const { isNotValid, errMsg, name, value } = this.state;

    return (
      <Modal show={isCollaboratorExpenseModalOpen} onHide={() => setIsCollaboratorExpenseModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>New Collaborator Expense</Modal.Title>
        </Modal.Header>
        <Modal.Body className="transaction-gci-content" style={{ padding: "0 15px" }}>
          <div className="transaction-gci-options transaction-modal">
            {isNotValid && <Error errorMessage={errMsg} />}
            <Form horizontal>
              <FormGroup>
                <Col xs={12}>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label>Name</label>
                  <div>
                    <Input
                      value={name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                  </div>
                </Col>
                <Col xs={4}>
                  <div className="flat-input transaction-input">
                    <Input value={value} onChange={(e) => this.setState({ value: e.target.value })} />
                    <span>$</span>
                  </div>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col xs={12}>
                  <Button
                    bsSize="small"
                    className="modal-cancel"
                    onClick={() => setIsCollaboratorExpenseModalOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    bsSize="small"
                    className="modal-submit pull-right"
                    onClick={() => this.saveExpenseData()}
                  >
                    Save
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

CollaboratorExpenseModal.propTypes = {
  isCollaboratorExpenseModalOpen: PropTypes.bool.isRequired,
  setIsCollaboratorExpenseModalOpen: PropTypes.func.isRequired,
  listingData: PropTypes.shape().isRequired,
  collaboratorModalIndex: PropTypes.number.isRequired,
  setFinancialData: PropTypes.func.isRequired,
  recalculateCollaboratorExpenses: PropTypes.func.isRequired,
};

export default CollaboratorExpenseModal;
